import { useEffect, useRef, useState } from "react";
import { portalApi } from "./portalApi";

const BATCH = 40;

// Auto-translates project content for non-English portal languages.
// entries: [{ key, text }] — must be memoized by the caller.
export function useContentTranslation(slug, lang, entries) {
  const [tmap, setTmap] = useState({});
  const cacheRef = useRef({});
  const langRef = useRef(lang);

  useEffect(() => {
    if (langRef.current !== lang) {
      cacheRef.current = {};
      setTmap({});
      langRef.current = lang;
    }
    if (!slug || !lang || lang === "en" || !entries || !entries.length) return;
    const pending = entries.filter(
      (e) => e.text && e.text.trim() && cacheRef.current[e.key] === undefined
    );
    if (!pending.length) return;
    pending.forEach((e) => { cacheRef.current[e.key] = null; });
    (async () => {
      for (let i = 0; i < pending.length; i += BATCH) {
        const batch = pending.slice(i, i + BATCH);
        try {
          const d = await portalApi.translateContent(slug, {
            target_lang: lang,
            items: batch.map(({ key, text }) => ({ key, text })),
          });
          if (langRef.current !== lang) return;
          Object.assign(cacheRef.current, d.translations || {});
          setTmap({ ...cacheRef.current });
        } catch {
          // Un-mark failed keys so a later render retries them.
          pending.slice(i).forEach((e) => {
            if (cacheRef.current[e.key] === null) delete cacheRef.current[e.key];
          });
          return;
        }
      }
    })();
  }, [slug, lang, entries]);

  return lang === "en" ? {} : tmap;
}
